module.exports = __webpack_public_path__ + "img/default_avatar.6b83005a.png";